(() => {
  if (window.MOTCompleteSetGridLoaded) return;
  window.MOTCompleteSetGridLoaded = true;

  const updateArrows = (grid) => {
    const root = grid.closest('.mot-complete-set--carousel');
    if (!root) return;
    const max = Math.max(0, grid.scrollWidth - grid.clientWidth);
    root.querySelector('[data-mot-upsell-direction="-1"]').disabled = grid.scrollLeft <= 2;
    root.querySelector('[data-mot-upsell-direction="1"]').disabled = grid.scrollLeft >= max - 2;
  };
  const observer = new ResizeObserver((entries) => entries.forEach(({ target }) => updateArrows(target)));
  const observed = new WeakSet();
  const initCarousels = () => {
    document.querySelectorAll('.mot-complete-set--carousel .mot-complete-set__grid').forEach((grid) => {
      if (!observed.has(grid)) { observer.observe(grid); observed.add(grid); }
      updateArrows(grid);
    });
  };
  document.addEventListener('scroll', (event) => {
    if (event.target.matches?.('.mot-complete-set--carousel .mot-complete-set__grid')) updateArrows(event.target);
  }, true);
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-mot-upsell-direction]');
    if (!arrow || arrow.disabled) return;
    const grid = arrow.closest('.mot-complete-set').querySelector('.mot-complete-set__grid');
    const step = grid.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(grid).columnGap) || 0);
    grid.scrollBy({ left: Number(arrow.dataset.motUpsellDirection) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  document.addEventListener('shopify:section:load', initCarousels);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCarousels);
  else initCarousels();

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mot-upsell-variant-select]');
    if (!select) return;

    const controls = select.closest('.mot-complete-set__tile-controls');
    const button = controls?.querySelector('[data-mot-upsell-tile-add]');
    if (button) button.dataset.variantId = select.value;
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mot-upsell-tile-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const label = button.querySelector('[data-mot-upsell-tile-label]');
    const originalLabel = label?.textContent || 'Add';
    button.disabled = true;
    if (label) label.textContent = 'Adding…';

    const formData = new FormData();
    formData.append('id', button.dataset.variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-items,cart-footer,cart-item-count');
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const responseText = await response.text();
      let data = {};
      try { data = responseText ? JSON.parse(responseText) : {}; } catch (_) {}
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item');

      if (label) label.textContent = 'Added';
      try {
        document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
          bubbles: true,
          detail: { response: data, sourceId: 'mot-complete-set-grid' },
        }));
      } catch (_) {}
      window.setTimeout(() => { if (label) label.textContent = originalLabel; }, 1800);
    } catch (_) {
      if (label) label.textContent = 'Try again';
    } finally {
      button.disabled = false;
    }
  }, true);
})();

document.addEventListener('click', event => {
  const button = event.target.closest('[data-mot-upsell-notify]');
  if (!button) return;
  const controls = button.closest('.mot-complete-set__tile-controls');
  const variantId = controls.querySelector('[data-mot-upsell-notify-variant]')?.value || button.dataset.variantId;
  window.dispatchEvent(new CustomEvent('mot-preorder-notify-open', {detail: {formId: button.dataset.notifyForm, variantId}}));
});
